export const validatePath = (lookingPath) =>
	window.location.pathname.includes(lookingPath);
